// Acesso a dados de `supplies` (catálogo pessoal de insumos, Etapa 10).
// Mesma regra de src/features/projects/projectRepository.ts: leituras são
// `select` direto, toda escrita passa pelos helpers de src/db/writes.ts.
import { and, eq, isNull } from 'drizzle-orm';
import { supplies, type Supply, type NewSupply } from '../../db/schema';
import { insertRecord, updateRecord, softDeleteRecord } from '../../db/writes';
import type { AppDatabase } from '../../db/outbox';

export async function listSupplies(db: AppDatabase, userId: string): Promise<Supply[]> {
  return db
    .select()
    .from(supplies)
    .where(and(eq(supplies.userId, userId), isNull(supplies.deletedAt)));
}

export type NewSupplyInput = Pick<NewSupply, 'userId' | 'type' | 'name' | 'unit' | 'unitPrice'>;

/** Cria um insumo novo diretamente no catálogo (fluxo da tela Catálogo).
 * O fluxo "criar inline a partir de um projeto" usa
 * `createSupplyAndLinkToProject` (src/features/projects/linkSupply.ts), que
 * chama insertRecord internamente do mesmo jeito. */
export async function createSupply(db: AppDatabase, data: NewSupplyInput): Promise<Supply> {
  return insertRecord(db, supplies, data);
}

export type SupplyPatch = Partial<Pick<NewSupply, 'type' | 'name' | 'unit' | 'unitPrice'>>;

/**
 * Atualiza um insumo do catálogo — inclusive o preço. Alterar `unitPrice`
 * aqui NÃO reescreve `unit_price_snapshot` de nenhum `project_supplies` já
 * gravado (esses vínculos não são tocados por esta função nem por nenhum
 * outro código deste módulo) — é assim que a spec S02 protege o histórico
 * de custo de projetos antigos. Ver src/features/projects/linkSupply.ts
 * para onde o snapshot é lido e gravado.
 */
export async function updateSupply(db: AppDatabase, id: string, patch: SupplyPatch): Promise<Supply> {
  return updateRecord(db, supplies, id, patch);
}

export async function deleteSupply(db: AppDatabase, id: string): Promise<void> {
  await softDeleteRecord(db, supplies, id);
}
